import { render, staticRenderFns } from "./BasePwdModify.vue?vue&type=template&id=4a08c8ce&scoped=true"
import script from "./BasePwdModify.vue?vue&type=script&lang=js"
export * from "./BasePwdModify.vue?vue&type=script&lang=js"
import style0 from "./BasePwdModify.vue?vue&type=style&index=0&id=4a08c8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08c8ce",
  null
  
)

export default component.exports